function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import SvgMore from "@digital-hig/icon/lib/esm/icons/more";
export var makeBreadcrumbsStyles = function makeBreadcrumbsStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiBreadcrumbs: {
      defaultProps: {
        slots: {
          CollapsedIcon: SvgMore
        }
      },
      styleOverrides: {
        root: _objectSpread({}, tokens.typography["body-copy-small"]),
        ol: {
          "& li:not([class*='MuiBreadcrumbs-li']) > [class*='MuiButtonBase-root']": {
            backgroundColor: "transparent",
            borderRadius: primitives.borderRadii.medium,
            padding: primitives.spacings["1"],
            "& svg": {
              width: "unset"
            },
            "&:hover": {
              boxShadow: tokens.effects["halo-hover"]
            },
            "&:active, &:active:focus-visible": {
              boxShadow: tokens.effects["halo-pressed"]
            },
            "&:focus-visible": {
              boxShadow: tokens.effects["focus-ring-thin"]
            }
          }
        },
        li: {
          "& [class*='MuiLink-root']": {
            color: tokens.colors["text-link-visited"],
            borderRadius: primitives.borderRadii.medium,
            lineHeight: "24px",
            // TO-DO: update when new line height primitives available. Tech debt: https://git.autodesk.com/dpe/digital-hig/issues/1201
            "&:active, &:visited:active": _objectSpread({}, tokens.textLink.pressedState),
            "&:focus-visible": {
              textDecorationColor: tokens.colors["text-link-visited"]
            },
            "&:hover, &:active, &:focus, &:focus-visible, &:visited, &:visited:hover": {
              color: tokens.colors["text-link-visited"]
            }
          }
        },
        separator: {
          color: tokens.colors["text-link-visited"]
        }
      }
    }
  };
};